pnk-chips {
    /* Component styles go here */
}
